<template>
	<tr class="record">
		<td class="py-1">{{ item.version }}</td>
		<td class="py-1">{{ item.created_at | dateFormatter }}</td>
		<td>{{ item.created_user.full_name }}</td>
		<td><p>{{ item.reason }}</p></td>
		<td class="py-1">{{ item.source_of_base_material | sourceOfBaseMaterialFormatter }}</td>
		<td class="py-1">{{ item.arrangement_availability | arrangementAvailabilityFormatter }}</td>
		<td class="py-1">{{ item.scheduled_date_of_payment | dateFormatter }}</td>
		<td class="py-1">{{ item.scheduled_date_of_approval | dateFormatter }}</td>
		<td class="py-1">{{ item.source_of_transport }}</td>
		<td class="py-1">{{ item.transport }}</td>
		<td class="py-1">{{ item.exists_coating | existenceFormatter }}</td>
		<td class="py-1"><p>{{ item.coating_content }}</p></td>
		<td class="py-1">{{ item.exists_process_photo | existenceFormatter }}</td>
		<td class="py-1"><p>{{ item.process_photo_content }}</p></td>
		<td class="py-1">{{ item.exists_water_works | existenceFormatter }}</td>
		<td class="py-1"><p>{{ item.water_works_content }}</p></td>
		<td class="py-1">{{ item.exists_witness | existenceFormatter }}</td>
		<td class="py-1"><p>{{ item.witness_content }}</p></td>
		<td class="py-1">{{ item.exists_packaging | existenceFormatter }}</td>
		<td class="py-1"><p>{{ item.packaging_content }}</p></td>
		<td class="py-1">{{ item.exists_attached_file | existenceFormatter }}</td>
		<td class="py-1"><p>{{ item.attached_file_content }}</p></td>
		<td class="py-1"><p>{{ item.content }}</p></td>
		<td class="py-1">{{ item.exists_quotation_cost | existenceFormatter }}</td>
		<td class="py-1">{{ item.exists_order_amount | existenceFormatter }}</td>
		<td class="py-1">{{item.is_approved | approvalFormatter }}</td>
		<td class="py-1">
			<span v-for="user_name in item.approved_users" :key="user_name">
				{{user_name}}
			</span>
		</td>
	</tr>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	filters: {
		dateFormatter(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD")
			}
		},
		sourceOfBaseMaterialFormatter(item) {
			switch (item) {
				case "free":
					return "無償支給"
					break
				case "own":
					return "KG手配"
					break
			}
		},
		arrangementAvailabilityFormatter(item) {
			switch (item) {
				case true:
					return "可"
					break
				case false:
					return "否"
					break
			}
		},
		existenceFormatter(item) {
			switch (item) {
				case true:
					return "有"
					break
				case false:
					return "無"
					break
			}
		},
		approvalFormatter(item) {
			switch (item) {
				case true:
					return "承認"
					break
				case false:
					return "非承認"
					break
			}
		},
	},
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		authorized: {
			type: Boolean,
			default: false,
			required: false,
		},
	},

	data() {
		return {}
	},
	mounted() {
	},
}
</script>

<style scoped lang="scss">
th,
td {
	border-left: solid gray 1px;
}
p {
	white-space: pre-wrap;
}

.record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.matter-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
</style>
